export default "__VITE_ASSET__EfegqGaF__"